module.exports = __webpack_public_path__ + "87cff034db4b84e0d2c253588afd1b67.png";